import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { notNull, notUndefined } from "../../utils/type-guards/general";

export type Breadcrumb = {
	label: string;
	link?: string;
	position?: string;
};

export const getBreadcrumbs = (
	currentLabel: string,
	homeLabel: string,
	buttons?: readonly (Queries.ButtonFragment | null)[] | null,
): Breadcrumb[] | undefined => {
	const breadcrumbs: Breadcrumb[] | undefined =
		buttons
			?.filter(notNull)
			.map((breadcrumb) =>
				breadcrumb.label && breadcrumb.link
					? {
							label: breadcrumb.label,
							link: getUrlFromStoryblokLink(breadcrumb.link),
						}
					: undefined,
			)
			.filter(notUndefined) ?? [];
	const breadcrumbsWithCurrentPage = [
		{ label: homeLabel, link: "/" },
		...breadcrumbs,
		{ label: currentLabel },
	];
	return breadcrumbsWithCurrentPage;
};
